import { Link } from "react-router-dom";
import { typeLabels, type Media } from "@/utils/media";

interface MediaCardProps {
  media: Media;
  showSynopsis?: boolean;
}

export default function MediaCard({ media, showSynopsis = true }: MediaCardProps) {
  return (
    <Link to={`/detail/${media.id}`} className="group block">
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={media.poster}
          alt={media.title}
          title={`${media.title} 高清海报 - 亚洲一区二区在线`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded bg-accent-500 px-1.5 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {media.rating.toFixed(1)}
        </span>
        {media.isNew && (
          <span className="absolute left-2 top-2 rounded bg-primary-500 px-1.5 py-0.5 text-[10px] font-semibold text-background-50">
            NEW
          </span>
        )}
        <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-foreground-950/90 via-foreground-950/25 to-transparent p-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          {showSynopsis && (
            <p className="line-clamp-3 text-xs leading-relaxed text-background-100">
              {media.synopsis}
            </p>
          )}
          <span className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-accent-300">
            <i className="ri-play-circle-line"></i>
            查看详情
          </span>
        </div>
      </div>
      <h3 className="mt-2 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
        {media.title}
      </h3>
      <p className="mt-1 truncate text-xs text-foreground-500">
        {typeLabels[media.type]} · {media.year} · {media.region}
      </p>
    </Link>
  );
}